<template>
  <transition name="popup-fade">
    <div class="popup" v-show="isShow" @click="cancel">
      <transition name="popup-move">
        <div class="popup-panel" :class="{'full-screen': fullScreen}" v-show="isShow" @click.stop="noop">
          <div class="popup-choose border-bottom-1px" v-if="showChoose">
            <span class="cancel" @click="cancel">{{cancelTxt}}</span>
               <h1 class="popup-title">{{title}}</h1>
            <span class="confirm" @click="confirm">{{confirmTxt}}</span>
          </div>
          <slot class="popup-content"></slot>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script type="text/ecmascript-6">
import { i18n } from '@/common/utils/i18n'

export default {
  name: 'Popup',
  props: {
    title: {
      type: String
    },
    cancelTxt: {
      type: String,
      default: i18n.gettext('取消')
    },
    confirmTxt: {
      type: String,
      default: i18n.gettext('确定')
    },
    selectedIndex: {
      type: Array,
      default: () => ([])
    },
    showChoose: {
      type: Boolean,
      default: true
    },
    value: {
      type: Boolean,
      default: false
    },
    fullScreen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShow: false
    }
  },
  methods: {
    noop () {},
    show (next) {
      this.isShow = true
      if (next && typeof next === 'function') {
        this.$nextTick(() => {
          next()
        })
      }
    },
    hide (next) {
      this.isShow = false
      if (next && typeof next === 'function') {
        this.$nextTick(() => {
          next()
        })
      }
    },
    confirm () {
      this.hide()
      this.$emit('confirm')
    },
    cancel () {
      this.hide()
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss">
.popup {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 50;
  width: 100%;
  // height: 100%;
  overflow: hidden;
  text-align: center;
  font-size: $fontsize-medium;
  background-color: $color-mask-bgc;
  &.popup-fade-enter, &.popup-fade-leave-active {
    opacity: 0;
  }
  &.popup-fade-enter-active, &.popup-fade-leave-active {
    transition: opacity .3s ease-in-out;
  }
  .popup-panel {
    position: absolute;
    z-index: 50;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 273Px;
    background: $color-white;
    &.full-screen {
      height: 100vh;
    }
    &.popup-move-enter, &.popup-move-leave-active {
      transform: translate3d(0, 273Px, 0);
    }
    &.popup-move-enter-active, &.popup-move-leave-active {
      transition: transform .3s ease-in-out;
    }
    .popup-choose {
      color: $color-light-grey;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 60Px;
      .popup-title {
        margin: 0;
        line-height: 60Px;
        font-weight: normal;
        text-align: center;
        font-size: $fontsize-large;
        color: $color-dark-grey;
      }
      .confirm, .cancel {
        padding: 16Px 16px;
        font-size: $fontsize-medium;
      }
      .confirm {
        color: $color-orange;
        &:active {
          color: $color-active-light-orange-fe;
        }
      }
      .cancel {
        &:active {
          color: $color-active-light-gray-fe;
        }
      }
    }
  }
}
</style>
